
<script>
// @ is an alias to /src
import Layout from "@/layout/Main.vue";
import NoImageUrl from "@/assets/no-image.png";

export default {
	components: {
		Layout
	},

	data () {
		return {
			NoImageUrl,
			publicPath: process.env.BASE_URL,
			style: null,
			restaurant: [],
			showForm: false,
			showPay: false,

			r_id: '',
			branch_id: '',
			

			token: '',
			uid: '',

			counter: 1,
			cart: [],
			data: {},
			extras: {},
			addresses: [],
			guestAddresses: [],
			address_id: '',
			quantity: '',

			address: {
				name: "",
				area: "",
				flat: "",
				road_no:"",
				building: "",
				block: "",
				mobile: "",
				landmark: "",
				latitude: "",
				longitude:"",
			},
			total: "",


			location: '',
            marker: { position: { lat: null, lng: null } },
            center: { lat: null, lng: null },
            current_place: null,

            mapOptions: {
               disableDefaultUI: true,
            },
			
			delete: false,
			errors: {},

			sigofood_location: {},
			
		}
	},


	created() {
			this.style = document.createElement('link')
			this.style.setAttribute('rel', 'stylesheet')
			this.style.setAttribute('href', '/design/cart.css')
			document.head.appendChild(this.style)
			// this.getToken();
	},

	beforeDestroy() {
		document.head.removeChild(this.style);
	},

     mounted() {
        	this.fetchCart();
			// this.fetchExtras();
			this.fetchAddress();
      },
      methods: {

		getToken() {
			if (localStorage.getItem('sigofood_user')) {
				var sigofood_user =  JSON.parse(localStorage.getItem('sigofood_user'));
				if(sigofood_user.token) {
					// alert(sigofood_user.token);
				this.token = sigofood_user.token;
				this.uid = sigofood_user.uid;

				} else {
				this.$swal("", "Failed to fetch token, please login again", "error");
				this.$router.push({ name: "login" });
				}
				
			} else if(localStorage.getItem('sigofood_guest')) {
				var sigofood_guest =  JSON.parse(localStorage.getItem('sigofood_guest'));
				if(sigofood_guest.token) {
				this.guestToken = sigofood_guest.token;

				} else {
				this.$swal("", "Failed to fetch token, please login again", "error");
				this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
        }, 

        showModal(modal) {
         this.$refs[modal].show();
		},

		hideModal(modal) {
			this.$refs[modal].hide();
		}, 

		fetchLocation() {
			if (localStorage.getItem('sigofood_location')) {
									var sigofood_location =  JSON.parse(localStorage.getItem('sigofood_location'));
					this.latitude = sigofood_location.latitude;
										this.longitude = sigofood_location.longitude;
					this.block_no = sigofood_location.block_no;


					this.location = sigofood_location.place.name;
					this.sigofood_location = sigofood_location;
					console.log(this.location);
			} else {
				this.$router.push({ name: "location" });
			}
		}, 

        fetchCart() {
			this.getToken();

			if(this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

				const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.token,

				},
				};
				let url = "cart/getData?uid=" + this.uid + "&device_token=" + this.uid;          
				

				this.$axios
					.get(url, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.cart = responseData.data;
							this.total = responseData.total;

							console.log(this.cart);
							// this.fetchExtras();
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));

			} else {

				const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.guestToken,

				},
				};
				let url = "guest/getCartData";          
				

				this.$axios
					.get(url, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.cart = responseData.data;
							this.total = responseData.total;

							console.log(this.cart);
							// this.fetchExtras();
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));
			}
				
        },

		//sets the position of marker when dragged
		HandleMarkerDrag(e) {
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
        },

         //Moves the map view port to marker
        PanToMarker() {
            this.$refs.MapRef.panTo(this.marker.position);
            this.$refs.MapRef.setZoom(18);
        },

         //Moves the marker to click position on the map
        HandleMapClick(e) {
            this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            console.log(e);
        },     

        SetPlace(place) {
            this.current_place = place;
            if(this.current_place) {
               const marker = {
                  lat: this.current_place.geometry.location.lat(),
                  lng: this.current_place.geometry.location.lng(),
               };
               this.center = marker;
               this.marker.position = marker;
               this.location = place.formatted_address;
            }
        },



		fetchExtras() {
			this.getToken();

			if (this.uid) {
				if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

				const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.token,

				},
				};
				let url = "checkout/getExtras";   
				// console.log(this.cart[0].branch_id);
				let formData = new FormData();
				formData.append("restaurant_id", this.cart[0].r_id);
				// formData.append("restaurant_id", this.r_id);
				formData.append("device_token", this.uid); 
				
				this.$axios
					.post(url, formData, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.extras = responseData.data;
							console.log(this.extras);
							if(responseData.data.length) {
								this.showModal('extras-modal');
							} else {
								this.checkAddress(this.address_id);
							}
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));
 

			} else {
								
				const config = {
				headers: {
					"Content-type": "multipart/form-data",
					"Accept": "application/json",
					"Authorization": "Bearer " + this.guestToken,

				},
				};
				console.log(this.cart);
				let url = "guest/getExtras";   
				
				let formData = new FormData();
				formData.append("restaurant_id", this.cart[0].r_id);
				
				this.$axios
					.post(url, formData, config)
					.then((res) => {
						if(res.status == 200) {
							var responseData = res.data;
							console.log(responseData);
							this.extras = responseData.data;
							this.showModal('extras-modal');
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}                  
				})
				.catch((error) => {
					if (error.response) {
						if(error.response.status == 422) {               
							if (error.response.data) {
							this.errors = error.response.data.message;
							} 
							this.$swal("", error.response.statusText, "error");
							
						} else if(error.response.status == 500) {
							this.$swal("", error.response.statusText, "error");

						} else if(error.response.status == 401) {
							this.$swal("", error.response.statusText, "error");
							this.$router.push({ name: "login" });
							
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					} else {
						this.$swal("", error.message, "error");
					}
				})
				.finally(() => (this.loading = false));
			}
			
				
        	},


			fetchAddress() {
				this.getToken();
				
				if(this.uid) {
					if(localStorage.getItem('sigofood_uid')) {
						this.uid = localStorage.getItem('sigofood_uid');  
					} 

					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
					};
					let url = "address?uid=" + this.uid + "&device_token=" + this.uid;          
					
					this.$axios
						.get(url, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.addresses = responseData.data;

								console.log(this.addresses);
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));

				} else {
					
					const config = {
						headers: {
							"Content-type": "multipart/form-data",
							"Accept": "application/json",
							"Authorization": "Bearer ",
						},
					};

						let url = "address?uid=" + this.guestToken + "&device_token=" + this.guestToken;   

						
						this.$axios
							.get(url, config)
							.then((res) => {
								if(res.status == 200) {
									var responseData = res.data;
									console.log(responseData);
									this.guestAddresses = responseData.data;

									console.log(this.guestAddresses);

								} else {
									this.$swal("", "Something went wrong", "error");
								} 
																		
									
							})
							.catch((error) => {
								if (error.response) {
									if(error.response.status == 422) {               
										if (error.response.data) {
										this.errors = error.response.data.message;
										} 
										this.$swal("", error.response.statusText, "error");
										
									} else if(error.response.status == 500) {
										this.$swal("", error.response.statusText, "error");

									} else if(error.response.status == 401) {
										this.$swal("", error.response.statusText, "error");
										this.$router.push({ name: "login" });
										
									} else {
										this.$swal("", "Something went wrong", "error");
									}
								} else {
									this.$swal("", error.message, "error");
								}
							})
							.finally(() => (this.loading = false));
				}
				
        	},

			changeCounter: function(num){
				this.counter += +num
				// console.log(this.counter)
				!isNaN(this.counter) && this.counter > 0 ? this.counter : this.counter = 0;
            
			},
			

			//Update cart items
			updateCartItem(quantity, cart_id, type) {
				// this.cart[index].quantity = quantity;
				this.getToken();

				if(this.uid) {
					if(localStorage.getItem('sigofood_uid')) {
							this.uid = localStorage.getItem('sigofood_uid');  
						} 
					console.log(this.uid);
					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
					};
					let url = "cart/updateCart"; 

					let formData = new FormData();
					formData.append("uid", this.uid);
					formData.append("device_token", this.uid);
					formData.append("type", type);
					formData.append("cart_id", cart_id);
					formData.append("quantity", quantity);

					
					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.fetchCart();
								this.$router.push({name: "cart"});
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));

				}  else {
					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.guestToken,

					},
					};
					let url = "guest/updateCart";   

					let formData = new FormData();
					formData.append("type", type);
					formData.append("cart_id", cart_id);
					formData.append("quantity", quantity);
					
					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.fetchCart();
								this.$router.push({name: "cart"});
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));

				}
			},

			incrementCartItem(index,cart_id,type) {
				this.cart[index].quantity++;
				this.quantity = this.cart[index].quantity;
                this.updateCartItem(this.quantity,cart_id,type);
			},

			decrementCartItem(index,cart_id,type) {
				if (this.cart[index].quantity > 1) {
				this.cart[index].quantity--;
				}
				this.quantity = this.cart[index].quantity;
                this.updateCartItem(this.quantity,cart_id,type);
			},

			del(cart_id,type) {
				this.delete = false;
				this.$bvModal.msgBoxConfirm('Are you sure you want to delete this item?', {
					title: 'Confirm',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					this.delete = value
					if(this.delete){
					this.cart_id = cart_id;
					this.type = type;
					this.deleteCartItem(this.cart_id,this.type);
				}
				})
				.catch(err => {
					console.log(err);
				})
			},

			deleteCartItem(cart_id,type) {
				this.getToken();

				if(this.uid) {
					if(localStorage.getItem('sigofood_uid')) {
							this.uid = localStorage.getItem('sigofood_uid');  
						} 
					console.log(this.uid);
					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
					};
					let url = "cart/deleteCartData"; 

					let formData = new FormData();
					formData.append("uid", this.uid);
					formData.append("device_token", this.uid);
					formData.append("type", type);
					formData.append("cart_id", cart_id);
					
					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.fetchCart();
								this.$router.push({name: "cart"});
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));
					//window.location.reload();

				} else {
					
					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer ",

					},
					};
					let url = "guest/deleteCartData";   

					let formData = new FormData();
					formData.append("type", type);
					formData.append("cart_id", cart_id);
					
					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.fetchCart();
								this.$router.push({name: "cart"});
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));
					//window.location.reload();

				}
			},


			//Update extras
			updateExtraItem(quantity,extra_id) {
				// this.extras[index].quantity = quantity;
				this.getToken();

				if(this.uid) {
					if(localStorage.getItem('sigofood_uid')) {
							this.uid = localStorage.getItem('sigofood_uid');  
						} 
						console.log(this.uid);
					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
					};
					let url = "extras/addCart"; 

					let formData = new FormData();
					formData.append("device_token", this.uid);
					formData.append("extra_id", extra_id);
					formData.append("quantity", quantity);
					formData.append("branch_id", this.cart[0].branch_id);

					
					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.fetchCart();
								this.$router.push({name: "cart"});
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));

				} else {

					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.guestToken,

					},
					};
					let url = "guest/addExtraCart";   

					let formData = new FormData();
					formData.append("extra_id", extra_id);
					formData.append("quantity", quantity);
					formData.append("branch_id", this.cart[0].branch_id);
					
					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);

								console.log(this.extras);
								this.fetchCart();
								this.$router.push({name: "cart"});
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));

				}
			},


			incrementExtraItem(index,extra_id) {
				this.extras[index].quantity++;
				this.quantity = this.extras[index].quantity;
                this.updateExtraItem(this.quantity,extra_id);
			},

			decrementExtraItem(index,extra_id) {
				if (this.extras[index].quantity > 0) {
				this.extras[index].quantity--;
				}
				this.quantity = this.extras[index].quantity;
                this.updateExtraItem(this.quantity,extra_id);
			},
			
			addAddress() {
				this.errors = {
					area: [],
					flat: [],
					road_no: [],
					building: [],
					block: [],
					mobile: [],
					//location: [],
					latitude: [],
					longitude: [],
				};

				let is_valid = true;
				
				if(this.address.area == '') {
					this.errors.area[0] = 'Please enter area';
					is_valid = false;
				} 
				if (this.address.flat == '') {
					this.errors.flat[0] = 'Please enter flat name';
					is_valid = false;
				} 
				if(this.address.road_no == '') {
					this.errors.road_no[0] = 'Please enter road number';
					is_valid = false;
				} 
				if (this.address.building == '') {
					this.errors.building[0] = 'Please enter building number';
					is_valid = false;
				} 
				if(this.address.block == '') {
					this.errors.block[0] = 'Please enter block';
					is_valid = false;
				} 
				if (this.address.mobile == '') {
					this.errors.mobile[0] = 'Please enter mobile number';
					is_valid = false;
				}

				if (this.marker.position.lat == '') {
					this.errors.latitude[0] = 'Please choose your location';
					is_valid = false;
				}
					
				if (this.marker.position.lng == '') {
						this.errors.longitude[0] = 'Please choose your location';
						is_valid = false;
				}
				

				if (is_valid == true) {
			
					this.getToken();

					if (this.uid) {
						if(localStorage.getItem('sigofood_uid')) {
								this.uid = localStorage.getItem('sigofood_uid');  
							} 

						const config = {
						headers: {
							"Content-type": "multipart/form-data",
							"Accept": "application/json",
							"Authorization": "Bearer " + this.token,
						},
						};

						let url = "address/add";   

						let formData = new FormData();
							
							formData.append("uid", this.uid); 
							formData.append("device_token", this.uid); 
							formData.append("name", this.address.name);
							formData.append("area", this.address.area);
							formData.append("flat", this.address.flat);
							formData.append("road_no", this.address.road_no);
							formData.append("building", this.address.building);
							formData.append("block", this.address.block);
							formData.append("mobile", this.address.mobile);
							formData.append("landmark", this.address.landmark);
							//formData.append("latitude", this.location);
							formData.append("latitude", this.marker.position.lat);
							formData.append("longitude", this.marker.position.lng);
							
						this.$axios
							.post(url, formData, config)
							.then((res) => {
								if(res.status == 200) {
									var responseData = res.data;
									console.log(responseData);

								} else {
									this.$swal("", "Something went wrong", "error");
								} 
									
								this.clearForm();
									
									
							})
							.catch((error) => {
								if (error.response) {
									if(error.response.status == 422) {               
										if (error.response.data) {
										this.errors = error.response.data.message;
										} 
										this.$swal("", error.response.statusText, "error");
										
									} else if(error.response.status == 500) {
										this.$swal("", error.response.statusText, "error");

									} else if(error.response.status == 401) {
										this.$swal("", error.response.statusText, "error");
										this.$router.push({ name: "login" });
										
									} else {
										this.$swal("", "Something went wrong", "error");
									}
								} else {
									this.$swal("", error.message, "error");
								}
							})
							.finally(() => (this.loading = false));
							window.location.reload();
			
					} else {
						const config = {
						headers: {
							"Content-type": "multipart/form-data",
							"Accept": "application/json",
							"Authorization": "Bearer ",
						},
						};

						let url = "address/add";   

						let formData = new FormData();
							
							formData.append("uid", this.guestToken); 
							formData.append("device_token", this.guestToken); 
							formData.append("name", this.address.name);
							formData.append("area", this.address.area);
							formData.append("flat", this.address.flat);
							formData.append("road_no", this.address.road_no);
							formData.append("building", this.address.building);
							formData.append("block", this.address.block);
							formData.append("mobile", this.address.mobile);
							formData.append("landmark", this.address.landmark);
							formData.append("latitude", this.marker.position.lat);
							formData.append("longitude", this.marker.position.lng);
							
						this.$axios
							.post(url, formData, config)
							.then((res) => {
								if(res.status == 200) {
									var responseData = res.data;
									console.log(responseData);

								} else {
									this.$swal("", "Something went wrong", "error");
								} 
									
								this.clearForm();
									
									
							})
							.catch((error) => {
								if (error.response) {
									if(error.response.status == 422) {               
										if (error.response.data) {
										this.errors = error.response.data.message;
										} 
										this.$swal("", error.response.statusText, "error");
										
									} else if(error.response.status == 500) {
										this.$swal("", error.response.statusText, "error");

									} else if(error.response.status == 401) {
										this.$swal("", error.response.statusText, "error");
										this.$router.push({ name: "login" });
										
									} else {
										this.$swal("", "Something went wrong", "error");
									}
								} else {
									this.$swal("", error.message, "error");
								}
							})
							.finally(() => (this.loading = false));
							window.location.reload();

					}
				}
			},

			//Checking the choosed address is deliverable or not.
			checkAddress(address_id) {
				this.fetchLocation();
				this.getToken();

				if(this.uid) {
					if(localStorage.getItem('sigofood_uid')) {
							this.uid = localStorage.getItem('sigofood_uid');  
						} 
					const config = {
					headers: {
						"Content-type": "multipart/form-data",
						"Accept": "application/json",
						"Authorization": "Bearer " + this.token,

					},
					};
					let url = "delivery/checkAddress"; 

					let formData = new FormData();
					formData.append("uid", this.uid);
					formData.append("device_token", this.uid);
					formData.append("address_id", address_id);
					formData.append("branch_id", this.cart[0].branch_id);
					formData.append("restaurant_id", this.cart[0].r_id);
					formData.append("block_no", this.sigofood_location.block_no);
					// console.log(address_id);
					// console.log(this.cart[0].branch_id);
					// console.log(this.cart[0].r_id);
					// console.log(this.location.block_no);

					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.message = responseData.message;
								// alert(this.message);
								// this.$router.push({ name: "checkout" , params: {address_id: address_id} });

								if(responseData.status == true) {
									this.$router.push({ name: "checkout" , params: {address_id: address_id} });
								} else {
									this.$swal("", responseData.message, "error");
								}
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));

				} else {
					const config = {
						headers: {
							"Content-type": "multipart/form-data",
							"Accept": "application/json",
							"Authorization": "Bearer ",
						},
					};

					let url = "delivery/checkAddress"; 

					let formData = new FormData();
					formData.append("uid", this.guestToken);
					formData.append("device_token", this.guestToken);
					formData.append("address_id", address_id);
					formData.append("branch_id", this.cart[0].branch_id);
					formData.append("restaurant_id", this.cart[0].r_id);
					formData.append("block_no", this.sigofood_location.block_no);
					

					this.$axios
						.post(url, formData, config)
						.then((res) => {
							if(res.status == 200) {
								var responseData = res.data;
								console.log(responseData);
								this.message = responseData.message;
								if(responseData.status == true) {
									this.$router.push({ name: "checkout" , params: {address_id: address_id} });
								} else {
									this.$swal("", responseData.message, );
								}
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}                  
					})
					.catch((error) => {
						if (error.response) {
							if(error.response.status == 422) {               
								if (error.response.data) {
								this.errors = error.response.data.message;
								} 
								this.$swal("", error.response.statusText, "error");
								
							} else if(error.response.status == 500) {
								this.$swal("", error.response.statusText, "error");

							} else if(error.response.status == 401) {
								this.$swal("", error.response.statusText, "error");
								this.$router.push({ name: "login" });
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", error.message, "error");
						}
					})
					.finally(() => (this.loading = false));

				}

			},

			clearForm() {  
				this.address.name ="";         
				this.address.area = "";
				this.address.flat = "";
				this.address.road_no = "";
				this.address.building = "";
				this.address.block = "";
				this.address.mobile = "";
				this.address.landmark = "";
				this.address.latitude = "";
				this.address.longitude = "";

				this.marker = { position: { lat: null, lng: null } };
            this.center = { lat: null, lng: null };
            this.current_place = null;
            this.location = '';

				this.showForm = false;
				this.errors = {};
            },

			// addressCheck() {
			// 	alert(this.address_id);
			// }

		},

		


		

}
</script>



<template>
	<Layout>
		<br><br><br><br>

		<div class="container-sm" v-if="cart.length">
			<div class="row">
				<div class="col-lg-7 col-md-12">

					<!--Address-->
					
					<div class="column ">
						<div class="card" v-if="addresses" style="box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);  background-color: rgb(245, 244, 244);">

							<div class="card-body address" v-for="(address, index) in addresses" :key="index">
								
									<input type="radio" :value="address.address_id" v-model="address_id" name="address">
									{{address.building_no}}, {{address.area}}, {{address.block}}, {{address.flat}}, {{address.landmark}} 
									{{address.road_no}}, Mob:{{address.mobile}} 
							</div>
						</div>
						<div class="card" v-if="guestAddresses" style="box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);  background-color: rgb(245, 244, 244);">

							<div class="card-body address" v-for="(address, index) in guestAddresses" :key="index">
								
									<input type="radio" :value="address.ga_id" v-model="address_id" name="address">
									{{address.building_no}}, {{address.area}}, {{address.block}}, {{address.flat}}, {{address.landmark}} 
									{{address.road_no}}, Mob:{{address.mobile}} 
							</div>
						</div>
						<div v-else></div>
						
						<div class="card address-card">
							<div class="card-body add-address">
									
									<h5 class="card-title"><button class="accordion-button" type="button"
										data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
										aria-controls="collapseOne"  v-on:click="showForm = !showForm">Add a new delivery Address</button></h5>
										<p class="card-text mb-0"><small class="text-muted">You seem to be in the new location</small>
										</p>
										<!-- <img src="/sigofood-images/location.png" class="map-marker-icon"> -->
										<div class="map-marker-icon">
											<i class="material-icons">location_on</i>
										</div>
							</div>
							<div>
								<div v-if="showForm">
									<form>
										<div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
								
											<div class="accordion-body address-form">
												<hr class="m-0">												
												<div class="texts" @submit.prevent="addAddress()">
													<form class="form-horizontal" role="form">

														<p class="text-muted">Name <span class="text-danger">*</span></p>
														<div class="form-group">
															<input type="text" v-model="address.name" class="form-control form-control-sm"  placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.name) }">
															<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div>
														</div>

														<p class="text-muted">Location <span class="text-danger">*</span></p>
														<div class="form-group">
															<!-- <input type="text" v-model="address.location" class="form-control form-control-sm"  placeholder=""> -->
															<GmapAutocomplete @place_changed="SetPlace" class="form-control form-control-sm" @keypress.enter="$event.preventDefault()" placeholder="Search here..."  v-bind:class="{ 'is-invalid': Boolean((errors.latitude && errors.latitude.length) || (errors.longitude && errors.longitude.length)) }"  :value="location"/>
															
															<GmapMap v-if="location"
																:center="center"
																:zoom="12"
																map-style-id="order-roadmap"
																:options="mapOptions"
																style="width: 100%; height: 30vmin"
																ref="MapRef"
																@click="HandleMapClick">
																	<GmapMarker
																	:position="marker.position"
																	:clickable="true"
																	:draggable="true"
																	@drag="HandleMarkerDrag"
																	@click="PanToMarker"
																	/>

																</GmapMap> 
																<div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
																	<p class="mb-0">{{ val }}</p>
																</div>	
																<div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
																	<p class="mb-0">{{ val }}</p>
																</div>	  
																
														</div>

														<p class="text-muted">Latitude</p>
														<div class="form-group">
															<input type="text" v-model="marker.position.lat" class="form-control form-control-sm"  placeholder="" >
															<!-- <div v-for="(val, index) in errors.area" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div> -->
														</div>

														<p class="text-muted">Longitude</p>
														<div class="form-group">
															<input type="text" v-model="marker.position.lng" class="form-control form-control-sm"  placeholder="">
															<!-- <div v-for="(val, index) in errors.area" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div> -->
														</div>

														<p class="text-muted">Area <span class="text-danger">*</span></p>
														<div class="form-group">
															<input type="text" v-model="address.area" class="form-control form-control-sm"  placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.area) }">
															<div v-for="(val, index) in errors.area" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div>
														</div>
														
														<p class="text-muted">Flat <span class="text-danger">*</span></p>
														<div class="form-group">
															<input type="text" v-model="address.flat" class="form-control form-control-sm"  placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.flat) }">
															<div v-for="(val, index) in errors.flat" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div>
														</div>

														<p class="text-muted">Road Number <span class="text-danger">*</span></p>
														<div class="form-group">
															<input type="text" v-model="address.road_no" class="form-control form-control-sm"  placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.road_no) }">
															<div v-for="(val, index) in errors.road_no" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div>
														</div>

														<p class="text-muted">Building Number <span class="text-danger">*</span></p>
														<div class="form-group">
															<input type="text" v-model="address.building" class="form-control form-control-sm"  placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.building) }">
															<div v-for="(val, index) in errors.building" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div>
														</div>

														<p class="text-muted">Block <span class="text-danger">*</span></p>
														<div class="form-group">
															<input type="text" v-model="address.block" class="form-control form-control-sm"  placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.block) }">
															<div v-for="(val, index) in errors.block" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div>
														</div>

														<p class="text-muted">Mobile Number <span class="text-danger">*</span></p>
														<div class="form-group">
															<input type="text" v-model="address.mobile" class="form-control form-control-sm"  placeholder="" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }">
															<div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
																<p class="mb-0">{{ val }}</p>
															</div>
														</div>

														<p class="text-muted">Landmark</p>
														<div class="form-group">
															<input type="text" v-model="address.landmark" class="form-control form-control-sm"  placeholder="">
														</div>
														<div>
															<!-- <input type="button" value="Save" class="right"> -->
															<button class="right mb-4" type="submit">Save</button>
														</div>
													</form>
												</div>
												
											</div>
										</div>
											
									</form>
								</div>
							</div>
								
							
						</div><br>
						
						<div class="card">
							
							<!-- <div class="card-body">
								
								<h5 class="card-title"><button class="accordion-button" type="button"
									data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true"
									aria-controls="collapseOne" v-on:click="showPay = !showPay">Payment</button></h5>
									<p class="card-text"><small class="text-muted">Pay with</small>
									</p>
									<img src="/design/sigofood-images/cash.png" class="map-marker-icon">
									
							</div>
							<div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample" v-if="showPay">
								<div class="accordion-body">
									<hr>
									<div class="texts">
										<div class="form-check">
											<div class="radio-block m-0 ">
												<div class="radio-outer">
													<input type="radio" name="cash" id="cash1" >
													<label for="cash1"></label>
												</div>
													
												<img src="/design/sigofood-images/cash2.png" class="cash-icon">
												<label class="form-check-label " for="cash1">
													Cash
												</label>
											</div>
										</div>
									</div>
								</div>
							</div> -->
						</div><br>
						</div>
					</div>

				

				<!--Cart-->

				<div class="col cart">
					<div class="card" style="box-shadow: 0px 0px 5px 0px rgba(16, 16, 16, 0.63);">
						<div class="class-header">Your Cart</div>
						<div  v-if="cart.length">
							<h5 class="card-title cart-title">{{cart[0].restaurant}}</h5>
						</div>
						<div v-else>
							<h5 class="card-title" style="margin-top: 30px; font-size: 16px;" >No items in your cart</h5>
						</div>
						
						<div class="card-body" v-for="(cartitem, index) in cart" :key="cartitem.cart_id">
							
							<div class="row">
								
								<div class="col">	

									<div id="outer">
										<div class="inner" v-if="parseInt(cartitem.quantity) > 1">
											<i class="material-icons" @click="decrementCartItem(index, cartitem.cart_id,cartitem.type)">remove_circle</i>
										</div>
										<div class="inner" v-else>
											<!-- <i class="material-icons" @click="decrementCartItem(index, cartitem.cart_id,cartitem.type)">cancel</i> -->
											<i class="material-icons" @click="del(cartitem.cart_id,cartitem.type)">cancel</i>
										</div>
										<div class="inner"><h4>{{cartitem.quantity}}</h4></div>
										<div class="inner">
											<i class="material-icons" @click="incrementCartItem(index , cartitem.cart_id,cartitem.type)">add_circle</i>
										</div>
									</div>
									<!-- <button @click="del(index)"></button> -->
								</div>
								
								<div class="col-6 cart-product-name cart-col">
									<h5>{{cartitem.product_name}}</h5>
								</div>
								<div class="col cart-product-price cart-col">
									<p class="mb-0">{{cartitem.price}} BHD</p>
									
								</div>
								<!-- <div class="col">
									<button @click="incrementCartItem(index , cartitem.cart_id,cartitem.type)">X</button>
								</div> -->
								<h6 class="mt-3" v-if="((index+1 < cart.length && cartitem.type=='p' && cart[index+1].type=='e') || cart[0].type=='e') ">Extras</h6>	
							</div>

						</div>
						<div class="card-body">
							<div class="total"  v-if="cart.length">
								<div class="row">
									<div class="col total-left">
										<h6>Total Amount</h6>
									</div>
									<div class="col total-right">
										<h6 class="text-theme">{{total}} BHD</h6>
									</div>
								</div><br>

								<div class="d-grid  col-12 mx-auto">
									<div class="box">
										<!-- <a class="btn checkout btn-block" href="#popup1" role="button"  @click="fetchExtras()" >Checkout</a> -->
										<a class="btn checkout btn-block" href="javascript:void(0);" role="button"  @click.prevent="fetchExtras()" >Checkout</a>

									</div>
								</div>
							</div>	

							
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="container-sm" v-else>
			<div class="row mb-5">
				<div class="col-12">
					<div class="text-center">
						<img src="/design/sigofood-images/cart_empty.png" alt="image">
						<h4>Your Cart is Empty</h4>
						<p>Looks like you haven t made your choice yet</p>
					</div>
				</div>
			</div>
		</div>

		<br>
		

		<b-modal id="extras-modal" ref="extras-modal" hide-footer>
	    	<template #modal-title>
	      	Add Extras
	    	</template>
	    	<div class="popup col-12">
				<div v-if="cart.length">
										
					<div class="content">
						<div class="card-1 mb-3 shadow-sm p-3" v-for="(extra, index) in extras" :key="extra.extra_id">
							<div class="row g-0" >
								
								<div class="col-md-12 d-flex">
									<div class="imgbox" >						
										<div v-if="extra.image" :style="{ 'background-image': 'url(' + $image_url + extra.image + ')' }"></div>

										<div v-else :style="{ backgroundImage: `url(${NoImageUrl})` }"></div>
									</div>
									<!-- <div class="card-body">
										<div class="row"> -->
											<div class="col ms-2 ms-lg-4">
												<h5 class="card-title ms-0">{{extra.name}}</h5>
												<p class="card-text ms-0"><small class="text-muted">{{extra.price}} BD</small></p>
											</div>
											<div class="col">											
												<div id="outer">
													<div class="inner">
														<i class="material-icons" @click="decrementExtraItem(index, extra.extra_id)">remove_circle</i>
													</div>
													<div class="inner"  @change="updateExtraItem(index, extra.quantity)"><h4>{{ extra.quantity }}</h4></div>
													<div class="inner">
														<i class="material-icons" @click="incrementExtraItem(index, extra.extra_id)">add_circle</i>
													</div>
												</div>
											</div>
																	
										<!-- </div>
									</div> -->
								</div>
							</div>
						</div>
					</div>
					<div style="margin-top: 30px;">
						<div class="inner"><button  class="btn btn-warning me btn-sm float-end btn-extras-checkout" data-inline="true" @click="checkAddress(address_id)">Checkout</button></div>
					</div>

				</div>
			</div>
	    	
	  	</b-modal>
	</Layout>
</template>


